export default __webpack_public_path__ + "static/media/A40E.50db9d6a.pdf";